module.exports = __webpack_public_path__ + "img/payment-invoice.35bbc86.svg";